import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostBinding,
  Input,
  Output,
  TemplateRef
} from '@angular/core';
import { BgColor } from '../../models';

@Component({
  selector: 'app-base-header',
  templateUrl: './base-header.component.html',
  styleUrls: ['./base-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class BaseHeaderComponent {
  @HostBinding('class')
  private get classes(): string {
    return `w-full min-h-16 h-16 flex items-center gap-x-3 ${this.sideGap} ${this.borderBottom} ${this.backgroundColor}`;
  }

  private get sideGap(): string {
    return this.hasSideGap ? 'px-6' : '';
  }

  @Input()
  title?: string | TemplateRef<any>;

  @Input()
  hasOverlappedBackgroundBlock = true;

  @Input()
  titleSuffix?: string;

  @Input()
  backButtonTooltipText?: string;

  @Input()
  hasBackButton?: boolean;

  @Input()
  hasBorderBottom? = true;

  @Input()
  hasSideGap? = true;

  @Input()
  titleRightBorder?: boolean;

  @Input()
  svgIcon?: string;

  @Input()
  bgColor?: BgColor;

  @Input()
  shouldTruncateTitle?: boolean;

  @Output()
  backButtonClick = new EventEmitter<void>();

  get isTitleTemplate(): boolean {
    return this.title instanceof TemplateRef;
  }

  get hasLeftContent(): boolean {
    const hasContent = this.hasBackButton
      || this.svgIcon
      || this.title
      || this.titleRightBorder;

    return !!hasContent;
  }

  get backgroundColor(): string {
    switch (this.bgColor) {
      case 'primary':
        return 'bg-navy-20';
      case 'secondary':
        return 'bg-blue-90-15';
      case 'tertiary':
        return 'bg-white';
      default:
        return 'bg-inherit';
    }
  }

  get borderBottom(): string {
    return this.hasBorderBottom ? 'border-b border-navy-90 border-opacity-10' : '';
  }

  goBack(): void {
    this.backButtonClick.emit();
  }
}
